<template>
  <UIButton v-bind="$props" type="submit" variant="success" class="da-submit">
    <slot> Submit </slot>
  </UIButton>
</template>

<script lang="ts">
export type SubmitButtonProps = Pick<UIButtonProps, "disabled" | "loading">;
</script>

<script lang="ts" setup>
import UIButton, { UIButtonProps } from "../UI/UIButton.vue";

defineProps<SubmitButtonProps>();
</script>
